import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Which e-commerce platforms do you support?",
    a: "InfluenceDetector works natively with Shopify, WooCommerce, BigCommerce, Wix, Squarespace, and Magento (Adobe Commerce) via each platform's official customer API. Custom or headless stores can connect through our REST API or CSV import.",
  },
  {
    q: "How does InfluenceDetector find creators in my customer list?",
    a: "We securely sync your customers from whichever store platform you use, then cross-reference email, name, and public social profile data across Instagram, TikTok, YouTube and X. Every match is verified before it appears in your dashboard.",
  },
  {
    q: "Is this GDPR and CCPA compliant?",
    a: "Yes. We only process customer data you already own and enrich it with publicly available social data. We never scrape private profiles, never buy creator lists, and you can delete synced data at any time.",
  },
  {
    q: "What's the match accuracy?",
    a: "Across 42M+ verified profiles, we hit a 94% confidence rate on handles for customers who use the same email across services. Every creator is scored and manually-verifiable before you reach out.",
  },
  {
    q: "Do I need a big customer list for this to work?",
    a: "No. Most stores see their first verified creator match within 500 orders. On average, 8.3% of e-commerce customers have 10K+ followers on at least one platform.",
  },
  {
    q: "Does it integrate with Klaviyo, Mailchimp, or Gorgias?",
    a: "Yes — on Growth and above. We push a 'Creator' tag plus follower metadata into your email or helpdesk platform so you can trigger segmented flows automatically.",
  },
  {
    q: "What happens after the 7-day trial?",
    a: "Your plan transitions to paid through your selected billing method. No separate invoice, no surprise renewals — cancel with one click from your dashboard.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-[#09090B]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#D4FF00] font-semibold">
            FAQ
          </p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl mt-4">
            Questions, <br /> answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-white/10"
            >
              <AccordionTrigger className="text-left font-display uppercase text-lg md:text-xl tracking-tight hover:no-underline hover:text-[#D4FF00] py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#A1A1AA] text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
